
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/customer-care/financial-support",
      function () {
        return require("private-next-pages/help/customer-care/financial-support/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/customer-care/financial-support"])
      });
    }
  